// extracted by mini-css-extract-plugin
module.exports = {"container":"header_container__3hoMn","title":"header_title__3EkoF","titleGoBack":"header_titleGoBack__21v4i"};